var path = '/templates/zenclerk_s/sites/list.html';
var html = "<div class=project-list><header>{{ 'sites.list.purojekuto_ichiran' | translate }}</header><div class=container><zcs-project-list projects=vm.projects></zcs-project-list></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/list.html
// module id = 1426
// module chunks = 0